const translations = {
  ar: {
    brand: 'حصيلة',
    brandEn: 'Haseela',
    nav: {
      home: 'الرئيسية',
      features: 'المميزات',
      plus: 'حصيلة بلس',
      pricing: 'الأسعار',
      about: 'عن حصيلة',
      demo: 'طلب تجربة',
      start: 'ابدأ الآن',
    },
    hero: {
      title: 'نظام ذكي لإدارة الديون والمصاريف بدقة واحترافية',
      subtitle: 'برنامج يساعدك على إدارة جميع الالتزامات المالية في مكان واحد - ديون العملاء، الموردين، الرواتب، المصاريف، والشيكات.',
      cta: 'طلب نسخة تجريبية',
      secondary: 'عرض المميزات',
    },
    featuresPreview: {
      title: 'كل ما تحتاجه لإدارة أعمالك',
      subtitle: 'أدوات متكاملة للديون والمصاريف والشيكات والرواتب',
    },
    featureItems: {
      customers: { title: 'إدارة الزبائن', desc: 'تتبع ديون العملاء — كاش، تقسيط، وشيكات في مكان واحد.' },
      suppliers: { title: 'إدارة الموردين', desc: 'سجل المشتريات ومستحقات الموردين مع تواريخ السداد.' },
      expenses: { title: 'إدارة المصاريف', desc: 'سجّل المصاريف اليومية والشهرية مع التصنيف والتحليل.' },
      employees: { title: 'إدارة الموظفين', desc: 'الرواتب والسلف والمستحقات بكفاءة ووضوح.' },
      checks: { title: 'نظام الشيكات', desc: 'تتبع الشيكات مع الصور والتواريخ والتنبيهات.' },
      reports: { title: 'تقارير مالية', desc: 'تقارير دقيقة عن الوضع المالي لأعمالك.' },
    },
    how: {
      title: 'كيف يعمل؟',
      subtitle: 'ثلاث خطوات بسيطة للبدء',
      step1: { title: 'اطلب تجربة', desc: 'أرسل رقم واتساب واسم محلك التجاري.' },
      step2: { title: 'فعّل التطبيق', desc: 'احصل على كود التفعيل وابدأ فوراً.' },
      step3: { title: 'تابع أعمالك', desc: 'ديون، شيكات، مصاريف، وتقارير في مكان واحد.' },
    },
    showcase: {
      customers: { title: 'إدارة الزبائن بوضوح', subtitle: 'مؤشرات سريعة وعمليات يومية أسهل' },
      system: { title: 'إدارة النظام بمرونة', subtitle: 'الوصول السريع لإدارات مختلفة' },
      activate: { title: 'فعّل التطبيق بسهولة', subtitle: 'أدخل كود التفعيل وابدأ العمل' },
    },
    cta: {
      title: 'ابدأ إدارة أعمالك بشكل احترافي',
      subtitle: 'اطلب نسخة تجريبية وسنساعدك على الإعداد خلال دقائق',
      button: 'طلب نسخة تجريبية',
    },
    featuresPage: {
      title: 'مميزات حصيلة',
      subtitle: 'نظام متكامل لإدارة الديون والمصاريف والمحلات',
    },
    featureDetails: {
      customers: {
        title: 'إدارة العملاء',
        points: [
          'تسجيل ديون العملاء مع التواريخ والملاحظات',
          'تتبع المدفوعات والمتبقي لكل عميل',
          'دعم الكاش والتقسيط والشيكات',
          'كشف حساب كامل لكل عميل',
        ],
      },
      suppliers: {
        title: 'إدارة الموردين',
        points: [
          'تسجيل المشتريات من الموردين',
          'تتبع المستحقات ومواعيد السداد',
          'كشف حساب مفصل لكل مورد',
          'ربط المشتريات بالمصاريف',
        ],
      },
      checks: {
        title: 'نظام الشيكات',
        points: [
          'تسجيل الشيكات الواردة والصادرة',
          'إرفاق صور الشيكات',
          'تنبيهات قبل موعد الاستحقاق',
          'تتبع حالة كل شيك',
        ],
      },
      employees: {
        title: 'الرواتب والسلف',
        points: [
          'تسجيل رواتب الموظفين شهرياً',
          'تتبع السلف والمستقطعات',
          'حساب صافي الراتب تلقائياً',
          'أرشيف كامل لكل موظف',
        ],
      },
      expenses: {
        title: 'إدارة المصاريف',
        points: [
          'تسجيل المصاريف مع التصنيف',
          'تتبع المصاريف الشهرية والسنوية',
          'ربط المصاريف بالمشتريات',
          'تقارير تحليلية للمصاريف',
        ],
      },
      alerts: {
        title: 'التنبيهات',
        points: [
          'تنبيهات مواعيد سداد الديون',
          'تنبيهات استحقاق الشيكات',
          'تنبيهات الرواتب والمستحقات',
          'إشعارات يومية وأسبوعية',
        ],
      },
    },
    pricing: {
      title: 'باقات الاشتراك',
      subtitle: 'اختر الباقة المناسبة لحجم عملك',
      customers: 'زبائن',
      suppliers: 'موردين',
      employees: 'موظفين',
      duration: 'المدة',
      whatsapp: 'واتساب',
      backup: 'نسخ احتياطي',
      discount: 'خصم',
      perPlan: 'للباقة',
      loading: 'جاري تحميل الباقات...',
      error: 'تعذر تحميل الباقات. حاول لاحقاً.',
      empty: 'لا توجد باقات متاحة حالياً.',
      request: 'اطلب هذه الباقة',
      currency: '₪',
    },
    about: {
      title: 'عن حصيلة',
      intro:
        'حصيلة نظام متكامل لإدارة الديون والمصاريف، صُمم للمحلات والشركات الصغيرة والمتوسطة. يجمع أدوات الإدارة المالية في منصة واحدة بسيطة وآمنة.',
      whyTitle: 'لماذا تم تطوير حصيلة؟',
      why1:
        'لاحظنا أن كثيراً من أصحاب الأعمال يعانون من تتبع الديون والمصاريف بالطرق التقليدية، مما يؤدي إلى أخطاء وخسائر غير محسوبة.',
      why2:
        'لذلك صممنا حصيلة ليكون الحل الأمثل — واجهة بسيطة لا تتطلب خبرة محاسبية.',
      badges: ['سهل الاستخدام', 'آمن وموثوق', 'يعمل أوفلاين', 'تقارير دقيقة'],
      missionTitle: 'رسالتنا',
      mission:
        'تمكين أصحاب الأعمال الصغيرة من إدارة أموالهم بدقة واحترافية دون خبرة محاسبية معقدة.',
      visionTitle: 'رؤيتنا',
      vision: 'أن يكون حصيلة النظام الأكثر ثقة لإدارة الديون في العالم العربي.',
      valuesTitle: 'قيمنا',
      values: 'البساطة، الدقة، الخصوصية، والثقة.',
      whoTitle: 'لمن هذا النظام؟',
      shops: { title: 'المحلات التجارية', desc: 'إدارة ديون العملاء والموردين مع تتبع الشيكات والمصاريف.' },
      sme: { title: 'الشركات الصغيرة والمتوسطة', desc: 'رواتب وسلف ومستحقات مع تقارير مالية شاملة.' },
      individuals: { title: 'الأفراد', desc: 'تتبع المصاريف والديون بطريقة منظمة وآمنة.' },
    },
    plusPage: {
      eyebrow: 'النسخة الأونلاين',
      title: 'حصيلة بلس',
      subtitle:
        'النسخة السحابية من حصيلة — نفس قوة إدارة الديون والمصاريف، مع مزامنة فورية وبيانات آمنة على الخوادم.',
      whatTitle: 'ما هي حصيلة بلس؟',
      what1:
        'حصيلة بلس هي النسخة الأونلاين من تطبيق حصيلة. صُممت لتعمل عبر الإنترنت وتتصل بخوادم حصيلة الآمنة، فتبقى بيانات عملك متاحة من أكثر من جهاز وفي أي وقت.',
      what2:
        'تشمل إدارة الزبائن والموردين، الشيكات، المصاريف، الرواتب والسلف، التقارير، والتذكيرات — مع تسجيل دخول آمن واشتراك مرن عبر النظام.',
      benefitsTitle: 'لماذا حصيلة بلس؟',
      benefitsSubtitle: 'مزايا النسخة الأونلاين لأصحاب الأعمال الذين يحتاجون مرونة ووصولاً دائماً',
      benefits: [
        {
          icon: 'cloud',
          title: 'بيانات على السحابة',
          desc: 'تخزين آمن على خوادم حصيلة بدل الاعتماد على جهاز واحد فقط.',
        },
        {
          icon: 'sync',
          title: 'مزامنة مستمرة',
          desc: 'أي عملية تُحدَّث فوراً عبر الاتصال بالإنترنت وتظهر على الأجهزة المرتبطة.',
        },
        {
          icon: 'security',
          title: 'أمان أعلى',
          desc: 'حماية الحساب وتسجيل الدخول الآمن مع إدارة جلسات وصلاحيات أوضح.',
        },
        {
          icon: 'multi',
          title: 'عمل جماعي أسهل',
          desc: 'مناسبة للفرق والمحلات التي يحتاج أكثر من شخص للوصول لنفس البيانات.',
        },
        {
          icon: 'access',
          title: 'وصول من أي مكان',
          desc: 'تابع ديونك ومدفوعاتك من هاتفك أينما كنت طالما لديك اتصال.',
        },
        {
          icon: 'backup',
          title: 'حماية من فقدان البيانات',
          desc: 'بياناتك محفوظة مركزياً، فلا تضيع عند تغيير الجهاز أو تلفه.',
        },
      ],
      compareTitle: 'حصيلة وحصيلة بلس',
      compareSubtitle: 'اختر النسخة الأنسب لطريقة عملك',
      offline: {
        title: 'حصيلة (أوفلاين)',
        points: [
          'تعمل محلياً على الجهاز',
          'مناسبة بدون إنترنت دائم',
          'بيانات محفوظة على جهازك',
          'مثالية لمحل بجهاز واحد',
        ],
      },
      online: {
        title: 'حصيلة بلس (أونلاين)',
        points: [
          'تتصل بخوادم حصيلة الآمنة',
          'مزامنة بين الأجهزة',
          'وصول من أي مكان مع إنترنت',
          'مثالية للفرق والنمو',
        ],
      },
      cta: 'اطلب تجربة حصيلة بلس',
    },
    demo: {
      title: 'طلب نسخة تجريبية',
      subtitle: 'أدخل بياناتك وسنجهّز لك تجربة لمدة 3 أيام',
      storeName: 'اسم المحل التجاري',
      storePlaceholder: 'مثال: سوبر ماركت النور',
      ownerName: 'اسم صاحب المحل',
      ownerPlaceholder: 'الاسم الثلاثي',
      whatsapp: 'رقم الواتساب',
      whatsappPlaceholder: '05XXXXXXXX',
      versionType: 'نوع النسخة',
      online: 'نسخة الأونلاين',
      offline: 'نسخة الأوفلاين',
      address: 'العنوان',
      addressPlaceholder: 'المدينة / الشارع',
      digits: 'أرقام',
      submit: 'طلب التجربة',
      submitting: 'جاري الإنشاء...',
      note: 'سيتم إنشاء اشتراك تجريبي (3 days trail) مباشرة بعد التحقق من الرقم.',
      validation: 'يرجى تعبئة جميع الحقول برقم واتساب صحيح.',
      submitError: 'تعذر إنشاء التجربة. حاول مرة أخرى.',
      successTitle: 'تم إنشاء التجربة بنجاح',
      successSubtitle: 'حمّل التطبيق وابدأ العمل فوراً',
      activationCode: 'كود التفعيل',
      activationHint: 'انسخ الكود وأدخله داخل تطبيق الأوفلاين عند التفعيل.',
      copy: 'نسخ',
      copied: 'تم النسخ',
      copyFailed: 'تعذر النسخ',
      downloadApps: 'حمّل التطبيق',
      googlePlay: 'Google Play',
      appStore: 'App Store',
      newRequest: 'طلب تجربة جديدة',
    },
    privacy: {
      title: 'سياسة الخصوصية',
      collectedTitle: 'البيانات التي نجمعها',
      collected: ['العملاء', 'الموردين', 'الرواتب', 'الشيكات', 'المصاريف', 'الصور المرفقة'],
      storageTitle: 'تخزين البيانات',
      storage: ['محلياً في النسخة الأوفلاين', 'أو على خوادم آمنة في النسخة الأونلاين'],
      principlesTitle: 'مبادئ حماية البيانات',
      principles: [
        'لا يتم بيع أو مشاركة البيانات مع أي طرف ثالث',
        'يتم استخدام الكاميرا فقط لالتقاط الإيصالات',
        'لا يتم جمع بيانات جهات الاتصال بشكل مباشر',
        'يمكن حذف البيانات أو الحساب في أي وقت',
      ],
    },
    deleteAccount: {
      title: 'حذف الحساب',
      subtitle: 'يمكنك طلب حذف حسابك وبياناتك المرتبطة بتطبيق حصيلة',
      stepsTitle: 'خطوات حذف الحساب',
      steps: [
        'تواصل معنا عبر واتساب أو البريد الإلكتروني',
        'أكد ملكية الحساب برقم الهاتف المسجّل',
        'سنقوم بحذف البيانات خلال فترة معقولة وفق سياسة الخصوصية',
      ],
      contact: 'تواصل لطلب الحذف',
    },
    footer: {
      tagline: 'نظام ذكي لإدارة الديون والمصاريف بدقة واحترافية.',
      links: 'روابط سريعة',
      contact: 'تواصل معنا',
      privacy: 'سياسة الخصوصية',
      delete: 'حذف الحساب',
      rights: 'جميع الحقوق محفوظة.',
    },
  },
  en: {
    brand: 'Haseela',
    brandEn: 'حصيلة',
    nav: {
      home: 'Home',
      features: 'Features',
      plus: 'Haseela Plus',
      pricing: 'Pricing',
      about: 'About',
      demo: 'Request Demo',
      start: 'Get Started',
    },
    hero: {
      title: 'A smart system to manage debts and expenses with precision and professionalism',
      subtitle: 'An app that helps you manage all financial obligations in one place — customer debts, suppliers, payroll, expenses, and checks.',
      cta: 'Request a free trial',
      secondary: 'See features',
    },
    featuresPreview: {
      title: 'Everything you need to run your business',
      subtitle: 'Integrated tools for debts, expenses, checks, and payroll',
    },
    featureItems: {
      customers: { title: 'Customer management', desc: 'Track customer debts — cash, installments, and checks in one place.' },
      suppliers: { title: 'Supplier management', desc: 'Record purchases and supplier dues with due dates.' },
      expenses: { title: 'Expense management', desc: 'Log daily and monthly expenses with categories.' },
      employees: { title: 'Employee management', desc: 'Salaries, advances, and dues — clear and efficient.' },
      checks: { title: 'Check system', desc: 'Track checks with photos, dates, and reminders.' },
      reports: { title: 'Financial reports', desc: 'Accurate reports on your business finances.' },
    },
    how: {
      title: 'How it works',
      subtitle: 'Three simple steps to get started',
      step1: { title: 'Request a trial', desc: 'Send your WhatsApp number and store name.' },
      step2: { title: 'Activate the app', desc: 'Receive your activation code and start immediately.' },
      step3: { title: 'Run your business', desc: 'Debts, checks, expenses, and reports in one place.' },
    },
    showcase: {
      customers: { title: 'Clear customer management', subtitle: 'Quick metrics and easier daily operations' },
      system: { title: 'Flexible system management', subtitle: 'Quick access to different modules' },
      activate: { title: 'Activate the app easily', subtitle: 'Enter your code and start working' },
    },
    cta: {
      title: 'Manage your business professionally',
      subtitle: 'Request a trial and we will help you set up in minutes',
      button: 'Request a free trial',
    },
    featuresPage: {
      title: 'Haseela Features',
      subtitle: 'An integrated system for debts, expenses, and store management',
    },
    featureDetails: {
      customers: {
        title: 'Customers',
        points: [
          'Record customer debts with dates and notes',
          'Track payments and remaining balance per customer',
          'Cash, installments, and checks supported',
          'Full statement for every customer',
        ],
      },
      suppliers: {
        title: 'Suppliers',
        points: [
          'Record supplier purchases',
          'Track dues and payment dates',
          'Detailed statement per supplier',
          'Link purchases to expenses',
        ],
      },
      checks: {
        title: 'Checks',
        points: [
          'Incoming and outgoing checks',
          'Attach check photos',
          'Reminders before due dates',
          'Track each check status',
        ],
      },
      employees: {
        title: 'Payroll & advances',
        points: [
          'Monthly salary records',
          'Track advances and deductions',
          'Automatic net salary calculation',
          'Full employee archive',
        ],
      },
      expenses: {
        title: 'Expenses',
        points: [
          'Categorized expense logging',
          'Monthly and yearly tracking',
          'Link expenses to purchases',
          'Analytical expense reports',
        ],
      },
      alerts: {
        title: 'Alerts',
        points: [
          'Debt due-date reminders',
          'Check maturity alerts',
          'Salary and dues reminders',
          'Daily and weekly notifications',
        ],
      },
    },
    pricing: {
      title: 'Subscription plans',
      subtitle: 'Choose the plan that fits your business size',
      customers: 'Customers',
      suppliers: 'Suppliers',
      employees: 'Employees',
      duration: 'Duration',
      whatsapp: 'WhatsApp',
      backup: 'Backup',
      discount: 'Discount',
      perPlan: 'per plan',
      loading: 'Loading plans...',
      error: 'Could not load plans. Please try again later.',
      empty: 'No plans available right now.',
      request: 'Request this plan',
      currency: '₪',
    },
    about: {
      title: 'About Haseela',
      intro:
        'Haseela is an integrated system for managing debts and expenses, designed for shops and SMEs. It brings financial tools into one simple, secure platform.',
      whyTitle: 'Why Haseela was built',
      why1:
        'Many business owners still track debts and expenses with notebooks or spreadsheets, which leads to errors and unexpected losses.',
      why2:
        'We built Haseela as a practical solution — a simple interface that needs no accounting expertise.',
      badges: ['Easy to use', 'Secure & reliable', 'Works offline', 'Accurate reports'],
      missionTitle: 'Our mission',
      mission:
        'Empower small businesses to manage money accurately and professionally without complex accounting skills.',
      visionTitle: 'Our vision',
      vision: 'To be the most trusted debt-management system in the Arabic-speaking world.',
      valuesTitle: 'Our values',
      values: 'Simplicity, accuracy, privacy, and trust.',
      whoTitle: 'Who is it for?',
      shops: { title: 'Retail shops', desc: 'Customer and supplier debts with checks and daily expenses.' },
      sme: { title: 'SMEs', desc: 'Payroll, advances, and dues with comprehensive financial reports.' },
      individuals: { title: 'Individuals', desc: 'Organize personal expenses and debts securely.' },
    },
    plusPage: {
      eyebrow: 'Online version',
      title: 'Haseela Plus',
      subtitle:
        'The cloud version of Haseela — the same debt and expense power, with live sync and secure server-side data.',
      whatTitle: 'What is Haseela Plus?',
      what1:
        'Haseela Plus is the online version of the Haseela app. It connects to Haseela’s secure servers so your business data stays available across devices, anytime you are online.',
      what2:
        'It covers customers, suppliers, checks, expenses, payroll and advances, reports, and reminders — with secure login and flexible subscription through the platform.',
      benefitsTitle: 'Why Haseela Plus?',
      benefitsSubtitle: 'Online advantages for businesses that need flexibility and constant access',
      benefits: [
        {
          icon: 'cloud',
          title: 'Cloud data',
          desc: 'Secure storage on Haseela servers instead of relying on a single device.',
        },
        {
          icon: 'sync',
          title: 'Continuous sync',
          desc: 'Every update syncs over the internet and appears on linked devices.',
        },
        {
          icon: 'security',
          title: 'Stronger security',
          desc: 'Secure login and clearer session and access management.',
        },
        {
          icon: 'multi',
          title: 'Easier teamwork',
          desc: 'Ideal for shops and teams where more than one person needs the same data.',
        },
        {
          icon: 'access',
          title: 'Access anywhere',
          desc: 'Follow debts and payments from your phone wherever you have a connection.',
        },
        {
          icon: 'backup',
          title: 'Protection from data loss',
          desc: 'Your data is stored centrally, so it is safer if a device is lost or replaced.',
        },
      ],
      compareTitle: 'Haseela vs Haseela Plus',
      compareSubtitle: 'Choose the version that fits how you work',
      offline: {
        title: 'Haseela (Offline)',
        points: [
          'Runs locally on the device',
          'Great when internet is limited',
          'Data stored on your device',
          'Ideal for one-device shops',
        ],
      },
      online: {
        title: 'Haseela Plus (Online)',
        points: [
          'Connects to secure Haseela servers',
          'Syncs across devices',
          'Access from anywhere with internet',
          'Ideal for teams and growth',
        ],
      },
      cta: 'Request a Haseela Plus trial',
    },
    demo: {
      title: 'Request a free trial',
      subtitle: 'Enter your details and we will set up a 3-day trial',
      storeName: 'Store name',
      storePlaceholder: 'e.g. Al-Noor Super Market',
      ownerName: 'Owner name',
      ownerPlaceholder: 'Full name',
      whatsapp: 'WhatsApp number',
      whatsappPlaceholder: '05XXXXXXXX',
      versionType: 'App version',
      online: 'Online version',
      offline: 'Offline version',
      address: 'Address',
      addressPlaceholder: 'City / street',
      digits: 'digits',
      submit: 'Request trial',
      submitting: 'Creating...',
      note: 'A trial subscription (3 days trail) will be created after phone validation.',
      validation: 'Please fill all fields with a valid WhatsApp number.',
      submitError: 'Could not create the trial. Please try again.',
      successTitle: 'Trial created successfully',
      successSubtitle: 'Download the app and start right away',
      activationCode: 'Activation code',
      activationHint: 'Copy the code and enter it in the offline app during activation.',
      copy: 'Copy',
      copied: 'Copied',
      copyFailed: 'Could not copy',
      downloadApps: 'Download the app',
      googlePlay: 'Google Play',
      appStore: 'App Store',
      newRequest: 'New trial request',
    },
    privacy: {
      title: 'Privacy Policy',
      collectedTitle: 'Data we collect',
      collected: ['Customers', 'Suppliers', 'Payroll', 'Checks', 'Expenses', 'Attached images'],
      storageTitle: 'Data storage',
      storage: ['Locally in the offline version', 'Or on secure servers in the online version'],
      principlesTitle: 'Data protection principles',
      principles: [
        'We do not sell or share data with third parties',
        'Camera is used only to capture receipts',
        'We do not collect contact-list data directly',
        'You can delete your data or account at any time',
      ],
    },
    deleteAccount: {
      title: 'Delete account',
      subtitle: 'You can request deletion of your Haseela account and related data',
      stepsTitle: 'How to delete your account',
      steps: [
        'Contact us via WhatsApp or email',
        'Confirm account ownership with your registered phone number',
        'We will delete the data within a reasonable period per our privacy policy',
      ],
      contact: 'Contact to request deletion',
    },
    footer: {
      tagline: 'A smart system for managing debts and expenses with accuracy and professionalism.',
      links: 'Quick links',
      contact: 'Contact',
      privacy: 'Privacy policy',
      delete: 'Delete account',
      rights: 'All rights reserved.',
    },
  },
};

export default translations;
